//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { searchTransactionBar } from '../components'
export default {
  name: 'RchgTransPage',
  extends: vComponent,
  components: { searchTransactionBar },
  data () {
    return {
      items: [], // 會員點數紀錄
      columns: [ // 欄位宣告
        { name: 'CREATEDATE',
          label: '交易時間',
          field: 'CREATEDATE',
          format: (val, row) => moment(val).format('YYYY/MM/DD')
        },
        { name: 'STOCK_NO',
          label: '門市名稱',
          field: 'STOCK_NO',
          format: (val, row) => this.storeKeyMap[`key_${val}`]
        },
        { name: 'MEMO',
          label: '交易類型',
          field: 'MEMO'
        },
        { name: 'RCHG_CASH',
          label: '儲值金額',
          field: 'RCHG_CASH'
        },
        { name: 'RCHG_PAY_CASH',
          label: '支付金額',
          field: 'RCHG_PAY_CASH'
        },
        { name: 'CRT_QUOTA',
          label: '餘額',
          field: 'CRT_QUOTA'
        }
      ],
      visibleColumns: ['CREATEDATE', 'STOCK_NO', 'MEMO', 'RCHG_CASH', 'RCHG_PAY_CASH', 'CRT_QUOTA'],
      pagination: {
        page: 1, // 目前第幾頁
        rowsPerPage: 50, // 每頁幾筆
        rowsNumber: 20 // 總筆數
      },
      meta: {},
      searchBarId: 'rchg_trans_record',
      queryOpt: null // 查詢參數
    }
  },
  computed: {
    ...mapGetters([
      'builderHost',
      'dateFormat',
      'site',
      'storeList'
    ]),
    storeKeyMap () {
      const result = {}
      this.storeList.forEach(item => {
        result[`key_${item.STOCK_NO}`] = item.STORE_NAME
      })
      return result
    }
  },
  async created () {
    if (this.$q.screen.lt.sm) {
      this.visibleColumns = ['CREATEDATE', 'RCHG_CASH', 'RCHG_PAY_CASH', 'CRT_QUOTA']
    }
    await this.doQuery()
  },
  mounted () {
    this.addHandler()
  },
  methods: {
    addHandler () {
      this.on('RchgTrans.Query', async () => {
        await this.doQuery()
      })
      this.on('SearchTransactionBar.Search', async (searchBarId, searchObj) => {
        if (searchBarId === this.searchBarId) {
          console.log(`searc obj searchBarId =${searchBarId}`)
          console.log(searchObj)
          let queryOpt = {}
          if (searchObj.STOCK_NO !== '') queryOpt.STOCK_NO = searchObj.STOCK_NO
          // 因為db存的是utc時間 所以查詢需要-8去查才會取得預期的結果
          const sDate = searchObj.sDate !== null && searchObj.sDate !== '' ? moment(searchObj.sDate).subtract(8, 'hour').format() : null
          const eDate = searchObj.eDate !== null && searchObj.eDate !== '' ? moment(searchObj.eDate).add(8, 'hour').format() : null
          console.log(`sDate=${sDate} eDate=${eDate}`)
          if (sDate !== null && eDate !== null) {
            // 區間
            console.log('between!!')
            queryOpt.CREATEDATE = [sDate, eDate] // 以array送出
          } else if (sDate !== null) {
            // 只有開始
            queryOpt.CREATEDATE = `>=${sDate}`
          } else if (searchObj.eDate !== null) {
            // 只有結束
            queryOpt.CREATEDATE = `<=${eDate}`
          }
          this.queryOpt = queryOpt
          await this.doQuery()
        }
      })
    },
    async doQuery () {
      const data = { SITE: this.site, ID_NO: this.params.id_no }
      data.countPerPage = this.pagination.rowsPerPage
      data.currentPage = this.pagination.page
      // 加入排序
      data.order = `CREATEDATE,DESC`
      // 加入查詢參數
      if (this.queryOpt !== null) {
        for (const prop in this.queryOpt) {
          if (this.queryOpt[prop] !== null) data[prop] = this.queryOpt[prop]
        }
      }
      const response = await this.fetch('builderApi', this.builderHost, 'crm_rchg_trans', data)
      this.items = response.data !== null ? response.data : []
      this.meta = response.meta
      this.pagination.rowsNumber = this.meta.total
    },
    async clickDetailBtn (props) {
    },
    async onRequest (props) {
      const { page, rowsPerPage } = props.pagination
      // const filter = props.filter
      this.pagination.page = page
      this.pagination.rowsPerPage = rowsPerPage
      console.log('on request props=')
      console.log(props)
      await this.doQuery()
    }
  }
}
